import React, { Component } from 'react'
import ReactAutosuggest from 'react-autosuggest'
import theme from './Autosuggest.scss'
import InputMessage from 'components/Input/InputMessage'
import InputValid from 'components/Input/InputValid'
import LoadingLinear from 'components/Loading/LoadingLinear'
import Tag from 'components/Tag'
import { throttle, uniqueId } from 'lodash'
import s from 'components/Input/Input/Input.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import { getLocation, getNumber, getTwilioNumbers, getContact } from './Autosuggest.utils'
import IconCloseThin from 'components/Icons/CloseThin'
import Button from 'components/Button/Button'

const getSuggestionValue = suggestion => suggestion.name
const renderSuggestion = suggestion => (
  <div className={cn(sLay['layout-row'], sLay['layout-align-start-center'])}>
    <span className={sLay.flex}>{suggestion.name}</span>
    {suggestion.tag && (
      <Tag idx={1} size="xs">
        {suggestion.tag}
      </Tag>
    )}
  </div>
)

export default class Autosuggest extends Component {
  static defaultProps = {
    value: '',
  }
  constructor() {
    super()
    this.state = {
      loading: false,
      suggestions: [],
      inputId: uniqueId('input'),
    }
  }
  onSuggestionsFetchRequested = ({ value }) => {
    const { numberType } = this.props
    this.setState({
      loading: true,
    })
    const { autosuggestType } = this.props
    if (autosuggestType === 'location') {
      getLocation(value).then(suggestions => {
        this.setState({
          suggestions,
          loading: false,
        })
      })
    } else if (autosuggestType === 'smartnumber') {
      getNumber(numberType, value).then(suggestions => {
        this.setState({
          suggestions,
          loading: false,
        })
      })
    } else if (autosuggestType === 'twilio') {
      getTwilioNumbers('AU', numberType, value).then(suggestions => {
        this.setState({
          suggestions,
          loading: false,
        })
      })
    } else if (autosuggestType === 'contact') {
      getContact(value).then(suggestions => {
        this.setState({
          suggestions,
          loading: false,
        })
      })
    }
  }
  onSuggestionsFetchRequestedThrottled = throttle(this.onSuggestionsFetchRequested, 1000, {
    leading: false,
    trailing: true,
  })
  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }
  onSuggestionSelected = (event, item) => {
    const { onSuggestionSelected } = this.props
    if (!(item.suggestion && item.suggestion.id && item.suggestion.id === 'noResults')) {
      return onSuggestionSelected(event, item)
    }
  }
  onClearRequested = () => {
    const { onClearRequested } = this.props
    this.setState({
      value: '',
    })
    if (onClearRequested) {
      onClearRequested()
    }
  }
  render() {
    const { inputId, suggestions, loading } = this.state
    const {
      input,
      labelUp,
      label,
      hideDot,
      info,
      meta: { touched, error, warning, active },
      placeholder,
      fullWidth,
      onClearRequested,
      display,
    } = this.props

    const outerClasses = cn(
      { [s.outer]: !display },
      { [s.outerBoxed]: display === 'box' },
      { [s.loading]: loading },
      { [s.invalid]: touched && error },
      { [s.inactive]: (!input.value || input.value.length === 0) && !labelUp },
      { [s.fullwidth]: fullWidth }
    )

    const labelClasses = cn(s.label)

    const inputProps = {
      onChange: input.onChange,
      value: typeof input.value === 'string' ? input.value : '',
      id: inputId,
      placeholder,
    }

    const suggestionsWithEmpty =
      suggestions.length === 0
        ? [{ id: 'noResults', name: loading ? 'Loading...' : 'No Results.' }]
        : suggestions

    return (
      <div className={outerClasses}>
        <label htmlFor={inputId} className={labelClasses}>
          {label}
        </label>
        <ReactAutosuggest
          theme={theme}
          suggestions={suggestionsWithEmpty}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedThrottled}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          onSuggestionSelected={this.onSuggestionSelected}
        />

        {onClearRequested && input.value.length > 0 && (
          <Button
            icon
            size="sm"
            onClick={this.onClearRequested}
            style={{ position: 'absolute', right: 0, top: 0 }}
          >
            <IconCloseThin size={20} />
          </Button>
        )}

        {loading && <LoadingLinear style={{ marginTop: '-2px' }} />}
        {!hideDot && <InputValid valid={!(error || warning) && !active && input.value} />}
        <InputMessage
          error={error}
          warning={(!input.value || input.value.length < 1) && info}
          touched={touched}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Autosuggest/Autosuggest.jsx